import React, { useEffect, useState } from "react";
import { Confirm, Icon, Label } from "semantic-ui-react";
import { InstitutionalDocument } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { CustomTable, BasicModal } from "../../../Shared";
import { buildStorageUrl, formatFileSize } from "../../../../utils";
import { InstitutionalDocumentForm } from "../InstitutionalDocumentForm";

const institutionalDocumentController = new InstitutionalDocument();

export function ListInstitutionalDocument(props) {
  const { reload, onReload, year } = props;
  const { accessToken } = useAuth();

  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [documentActive, setDocumentActive] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const response =
          await institutionalDocumentController.getInstitutionalDocuments(
            accessToken,
            year
          );
        setDocuments(response);
      } catch (error) {
        console.error(error);
        setDocuments([]);
      }
      setLoading(false);
    })();
  }, [accessToken, reload, year]);

  const openEdit = (row) => {
    setDocumentActive(row);
    setShowModal((prev) => !prev);
  };

  const onOpenCloseModal = () => setShowModal((prev) => !prev);

  const openDeleteConfirm = (row) => {
    setDocumentActive(row);
    setShowConfirm(true);
  };

  const onOpenCloseConfirm = () => setShowConfirm((prev) => !prev);

  const handleConfirm = () => {
    onDelete(documentActive);
    setShowConfirm(false);
  };

  const onDelete = async (document) => {
    setLoading(true);
    try {
      await institutionalDocumentController.deleteInstitutionalDocument(
        accessToken,
        document.id
      );
      onReload();
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const tableConfig = {
    headers: ["Título", "Año", "Descripción", "Archivo", "Acciones"],
    fields: [
      { field: "title", dataType: "text" },
      {
        field: "year",
        component: "custom",
        align: "center",
        render: (row) => <Label color="blue">{row.year}</Label>,
      },
      { field: "description", dataType: "text" },
      {
        field: "filePath",
        component: "custom",
        render: (row) => (
          <a
            href={buildStorageUrl(row.filePath)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon name="file pdf outline" color="red" />
            {row.fileName}
            {row.fileSize ? (
              <span style={{ color: "#999", marginLeft: 6 }}>
                ({formatFileSize(row.fileSize)})
              </span>
            ) : null}
          </a>
        ),
      },
      {
        align: "center",
        buttons: [
          {
            color: "blue",
            icon: "pencil",
            placeholder: "Editar documento",
            onClick: openEdit,
            permission: { module: "institutionalDocument", action: "update" },
          },
          {
            color: "red",
            icon: "trash",
            placeholder: "Eliminar documento",
            onClick: openDeleteConfirm,
            permission: { module: "institutionalDocument", action: "delete" },
          },
        ],
      },
    ],
    columnWidths: ["30%", "10%", "25%", "25%", "10%"],
  };

  return (
    <>
      <div className="institutional-document__list">
        <CustomTable
          tableConfig={tableConfig}
          data={documents}
          bordered
          hover
          striped
          loading={loading}
        />
      </div>
      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title={
          documentActive
            ? `Editar documento: ${documentActive.title}`
            : "Editar documento"
        }
      >
        <InstitutionalDocumentForm
          onClose={onOpenCloseModal}
          onReload={onReload}
          document={documentActive}
        />
      </BasicModal>
      <Confirm
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={showConfirm}
        onCancel={onOpenCloseConfirm}
        onConfirm={handleConfirm}
        content={`¿Eliminar el documento "${documentActive?.title || ""}" (${
          documentActive?.year || ""
        })?`}
        size="mini"
      />
    </>
  );
}
